import axios from "axios";

export const ping = async (apiToken: string) => {
    return await axios.get(`${process.env.REACT_APP_API_BASE_URL}/pings`, {
        headers: {
            Authorization: `Bearer ${apiToken}`,
        }
    });
}
